import React from 'react';
import { NavLinkWrapper } from '../styles/Main';
import { FormSectionStyled, FormContainerStyled } from '../styles/Form';

const ResetPasswordMessage = () => {
  return (
    <main>
      <FormSectionStyled>
        <FormContainerStyled>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✉️</div>
            <h1 style={{ fontSize: '24px', fontWeight: '600', margin: '0 0 12px 0' }}>Check your inbox</h1>
            <p style={{ fontSize: '15px', color: '#6b7280', margin: '0 0 24px 0', lineHeight: '1.5' }}>
              We've sent a password reset link to your email address. Click the link to create a new password.
            </p>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
              <NavLinkWrapper to="/signin">Back to sign in</NavLinkWrapper>
            </p>
          </div>
        </FormContainerStyled>
      </FormSectionStyled>
    </main>
  )
}
 
export default ResetPasswordMessage;